import React from 'react';
import {useParams, Navigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {selectAccessToken} from '@components/Login/userSlice';
import permissionsService from '@utils/permissionsService';
import {ACCESS_DENIED_PATH} from '@constants';

function withScopeGuard(Component) {
    return function ScopedComponent(props) {
        const urlParams = useParams();
        const accessToken = useSelector(selectAccessToken);
        if (!permissionsService.isAllowedScope({accessToken, urlParams})) {
            return <Navigate to={ACCESS_DENIED_PATH} replace />;
        }
        return <Component {...props} />;
    };
}

export default withScopeGuard;
